var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "gdpr-invites" },
    [
      _c("names-list", {
        ref: "namesList",
        attrs: {
          validate: _vm.validate,
          subTitle:
            "Invite those of your colleagues whose document locations you want scanned for GDPR risks.",
          regexForSplittingWhenPasting: new RegExp(",|;| |(?:\\n\\r)|\\n|\\t"),
          addTagOnKeys: ["Enter", ";", ",", " ", "Tab"],
          placeHolder: "Insert emails"
        }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "bottom-action" }, [
        _c(
          "button",
          { staticClass: "continue simple", on: { click: _vm.save } },
          [_vm._v("Next")]
        ),
        _vm._v(" "),
        _c("button", { staticClass: "back simple", on: { click: _vm.back } }, [
          _vm._v("Back")
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-14bcf97a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14bcf97a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./apps/account/GDPRInvites.vue
// module id = 485
// module chunks = 0